import { render, staticRenderFns } from "./ProductPlan.vue?vue&type=template&id=70c2815a"
import script from "./ProductPlan.vue?vue&type=script&lang=js"
export * from "./ProductPlan.vue?vue&type=script&lang=js"
import style0 from "./ProductPlan.vue?vue&type=style&index=0&id=70c2815a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports